import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/visitors/stay/search/`;

export type StaySearchResult = {
    id: string;
    ref: string;
    exit_time: string | null;
};

interface DTO {
    parkingId: string;
    ref: string;
}

const searchStay = ({ parkingId, ref }: DTO): Promise<StaySearchResult> =>
    axios.get(formatResourcePath(RESOURCE, { parkingId }), { params: { ref } });

export { RESOURCE as SEARCH_STAY_RESOURCE, searchStay };
